















export default
	name: 'CardCarousel'

	data: ->
		slidesToShow:
			desktopUp: 4
			desktopDown: 4
			tabletLandscapeDown: 3
			tabletDown: 2
			mobileLandscapeDown: 2
			mobileDown: 1

	props: block: Object

